import { useState } from "react";

export default function NoteRevisionModal({ noteInitiale, onRetour }) {
  const [note, setNote] = useState(noteInitiale || "");

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300 }}>
      <div style={{ background: "#f0f0f0", border: "1px solid #808080",
                    boxShadow: "3px 3px 8px rgba(0,0,0,0.3)", width: 480, maxWidth: "94vw" }}
           onClick={e => e.stopPropagation()}
           data-testid="note-revision-modal">
        <div style={{ background: "linear-gradient(180deg,#1e5aa8,#164a8f)", color: "#fff",
                      padding: "8px 12px", fontWeight: 700, fontSize: 15 }}>
          NOTE DE RÉVISION
        </div>
        <div style={{ padding: 20, fontSize: 14 }}>
          <p style={{ marginTop: 0, marginBottom: 10, fontWeight: 600 }}>
            Inscrivez la note de révision :
          </p>
          <textarea className="win-input" value={note}
                    onChange={e => setNote(e.target.value)}
                    maxLength={50} rows={3}
                    style={{ width: "100%", fontSize: 13, resize: "none", boxSizing: "border-box" }}
                    data-testid="note-revision-texte" autoFocus />
          <div style={{ fontSize: 11, color: "#666", marginTop: 4 }}>{note.length}/50 caractères</div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
            <button className="win-btn" onClick={() => onRetour(note.trim())}
                    style={{ fontWeight: "bold" }}
                    data-testid="note-revision-btn-retour">Retour</button>
          </div>
        </div>
      </div>
    </div>
  );
}
